import data from './Wingsurfing.yaml'
import { WithPage } from "../Components/PageSections/WithPage";

export default function Wingsurfing() {

  return WithPage(data, "wingsurflesson", "wingsurfrental")

}